import Vue from "vue";
import VueRouter from "vue-router";

import NavDetail from "../components/detail.vue";

Vue.use(VueRouter);
 
const router = new VueRouter({
  mode: 'hash', // 使用 hash 模式
  routes: [
	  
	  {
	  	path: '/',
	  	name: 'HomePage',
	  	// component: NavDetail,
	  	component: () => import('@/components/HomePage2.vue')
	  },
   
	{
		path: '/nav/:id',
		name: 'NavDetail',
		// component: NavDetail,
		component: () => import('@/components/detail.vue')
	},
	{
		path: '/about',
		name: 'About',
		// component: NavDetail,
		component: () => import('@/components/About.vue')
	},
	{
		path: '/disclaimers',
		name: 'Disclaimers',
		// component: NavDetail,
		component: () => import('@/components/Disclaimers.vue')
	},
  ],
  scrollBehavior(to, from, savedPosition) {
      // 始终滚动到顶部
      return { x: 0, y: 0 };
    }
});
 
export default router;